import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { FormatsService } from '../formats.service';
import { TechFormatNumer, TechGetDecimalInfo, Utils } from '../utils';

@Pipe({ name: 'trPercent' })
@Injectable({ providedIn: 'root' })
export class PercentPipe implements PipeTransform {
  constructor(private formats: FormatsService) {}

  transform(value: number, digitsInfo?: string): string {
    if (!Utils.isValue(value)) return '--';

    const decimalPlaces = TechGetDecimalInfo(digitsInfo);

    // Redondear el número a la cantidad deseada de decimales
    const roundedNumber = (value*100).toFixed(decimalPlaces);

    const t = TechFormatNumer(
      roundedNumber,
      this.formats.decimalCharacter,
      this.formats.digitGroupSeparator
    );

    return t + '%';
  }
}
